import { Tag as AntdTag, TagProps as AntdTagProps } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';

const StyledTag = styled(AntdTag)<{ labelColor: string }>`
  font-size: 10px;
  padding: 0 10px;
  border-radius: 5px;
  color: ${(props) => props.labelColor};
  display: flex;
  align-items: center;
  gap: 4px;

  .label {
    ${(props) => props.theme.typo.style.label};
    ${(props) => props.theme.typo.familyGoogle.regular};
  }

  // reset label margin
  &.ant-tag > .anticon + span,
  &.ant-tag > span + .anticon {
    margin-left: 0 !important;
  }
`;

export interface TagProps extends AntdTagProps {
  labelColor: string;
}

const Tag: FC<TagProps> = (props) => <StyledTag {...props} />;

export default Tag;
